export const GET_SPOT_OPEN_ORDERS_REQUEST = "GET_SPOT_OPEN_ORDERS_REQUEST";
export const GET_SPOT_OPEN_ORDERS_SUCCESS = "GET_SPOT_OPEN_ORDERS_SUCCESS";
export const GET_SPOT_OPEN_ORDERS_ERROR = "GET_SPOT_OPEN_ORDERS_ERROR";
export const REMOVE_SPOT_OPEN_ORDERS = "REMOVE_SPOT_OPEN_ORDERS";


export const GET_SPOT_ORDER_HISTORY_REQUEST = "GET_SPOT_ORDER_HISTORY_REQUEST";
export const GET_SPOT_ORDER_HISTORY_SUCCESS = "GET_SPOT_ORDER_HISTORY_SUCCESS";
export const GET_SPOT_ORDER_HISTORY_ERROR = "GET_SPOT_ORDER_HISTORY_ERROR";
export const REMOVE_SPOT_ORDER_HISTORY = "REMOVE_SPOT_ORDER_HISTORY";
